<template>
	<div class="c-global-checkout__row">
		<ConsentCheckbox
			v-for="consent in vm.consentChoices"
			:key="consent.consentChoiceId"
			:id="`scrolltarget-${vm.fieldName}`"
			:name="vm.fieldName"
			:model-value="modelValue.acceptTerms"
			@update:model-value="handleUpdate($event, consent.consentChoiceId)"
			:show-errors="showErrors"
			:error-message="vm.consentAgreementErrorMessage"
			:tab-index="modalLoginShow ? -1 : 0"
		>
			<template #label>
				<DsText text-type="body-md" class="short-text">
					<span v-html="consent.consentText"></span>
					<a
						v-if="consent.consentAgreementUrl"
						:href="consent.consentAgreementUrl"
						target="_blank"
						:title="consent.consentAgreementText"
					>
						{{ consent.consentAgreementText }}
					</a>
				</DsText>
			</template>
		</ConsentCheckbox>
	</div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { DsText } from '@coloplast/design-system';
import ConsentCheckbox from 'multisite/components/formElements/consentCheckbox.vue';
import { validateFieldState } from 'multisite/services/checkoutHelperService';

interface ConsentChoice {
	consentChoiceId: number | string;
	consentAgreementText: string;
	consentAgreementUrl: string;
	consentText: string;
}

interface ModelValue {
	acceptTerms: boolean;
	consentChoiceId: number | string;
}

interface ConsentProfileVm {
	fieldId: string;
	fieldName: string;
	clientSideInputType: string;
	name: string;
	title: string;
	consentAgreementErrorMessage: string;
	consentChoices: ConsentChoice[];
}

interface Props {
	modelValue: ModelValue;
	vm: ConsentProfileVm;
	showErrors: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits(['validate', 'update:model-value']);
const store = useStore();

const modalLoginShow = computed(() => store.getters['globalCheckout/getLoginModalShow']);

function handleUpdate(v: boolean, consentChoiceId: number | string) {
	validateField(v);

	emit('update:model-value', {
		acceptTerms: v,
		consentChoiceId: consentChoiceId,
	} as ModelValue);
}

function validateField(v: boolean) {
	const validateResult = validateFieldState(v, {
		required: true,
	});

	emit('validate', {
		key: props.vm.fieldName,
		value: validateResult,
	});
}

onMounted(() => {
	validateField(props.modelValue.acceptTerms);
});
</script>
